import GroupsBox from './GroupsBox';
import GroupsBoxWide from './GroupsBoxWide';
import { groupsContainerCreator } from './Groups.container';
import {
  GROUPS_ADMIN_IDS_STREAM,
  GROUPS_MEMBER_IDS_STREAM,
} from '../../../streams';

const GroupsAdminBox = groupsContainerCreator(GROUPS_ADMIN_IDS_STREAM)(
  GroupsBox
);
const GroupsMemberBox = groupsContainerCreator(GROUPS_MEMBER_IDS_STREAM)(
  GroupsBox
);

const GroupsAdminBoxWide = groupsContainerCreator(GROUPS_ADMIN_IDS_STREAM)(
  GroupsBoxWide
);
const GroupsMemberBoxWide = groupsContainerCreator(GROUPS_MEMBER_IDS_STREAM)(
  GroupsBoxWide
);

export {
  GroupsAdminBox,
  GroupsMemberBox,
  GroupsAdminBoxWide,
  GroupsMemberBoxWide,
};
